import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Main",
    component: () => import("@/views/main/Index.vue"),
    children: [
      // 营销获客
      {
        path: "/",
        name: "MarketingVisitor",
        component: () => import("@/views/marketing/visitor.vue"),
      },
      // 解决方案
      {
        path: "/solve/programme",
        name: "SolveProgramme",
        component: () => import("@/views/solve/programme.vue"),
      },
      // 精选产品
      {
        path: "/selected/products",
        name: "SelectedProducts",
        component: () => import("@/views/selected/products.vue"),
      },
      {
        path: "/selected/product1",
        name: "SelectedProduct1",
        component: () => import("@/views/selected/products1.vue"),
      },
      // {
      //   path: "/selected/product2",
      //   name: "SelectedProduct2",
      //   component: () => import("@/views/selected/products2.vue"),
      // },
      // {
      //   path: "/selected/product3",
      //   name: "SelectedProduct3",
      //   component: () => import("@/views/selected/products3.vue"),
      // },
      // {
      //   path: "/selected/product4",
      //   name: "SelectedProduct4",
      //   component: () => import("@/views/selected/products4.vue"),
      // },
      // {
      //   path: "/selected/product5",
      //   name: "SelectedProduct5",
      //   component: () => import("@/views/selected/products5.vue"),
      // },
      // {
      //   path: "/selected/product6",
      //   name: "SelectedProduct6",
      //   component: () => import("@/views/selected/products6.vue"),
      // },
      // {
      //   path: "/selected/product7",
      //   name: "SelectedProduct7",
      //   component: () => import("@/views/selected/products7.vue"),
      // },
      // {
      //   path: "/selected/product8",
      //   name: "SelectedProduct8",
      //   component: () => import("@/views/selected/products8.vue"),
      // },
      // 关于我们
      {
        path: "/about/us",
        name: "AboutUs",
        component: () => import("@/views/about/us.vue"),
      },
    ],
  },
  {
    path: "/activity/douyin",
    name: "activityDy",
    component: () => import("@/views/activity/douyin.vue"),
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
